import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="admin--reports"
export default class extends Controller {
  connect() {
    let tables = []
    const settings = {
      dom: 'Bfrtip',
      buttons: ['csv', 'excel', 'pageLength'],
      scrollCollapse: true,
      responsive: false,
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      pageLength: -1,
      columnDefs: [
        {
          targets: '_all',
          createdCell: function (td, cellData, rowData, row, col) {
            td.setAttribute('data-label', this[0].querySelectorAll('th')[col].innerText)
          },
        },
      ],
    }

    const countPlusInfo = ({ count, data }, type, row, meta) => loadBox(count, data, type, row, meta)

    const overviewColumns = [
      { data: 'name' },
      { data: 'groups' },
      { data: 'teachers' },
      {
        data: 'students',
        render: (data, _type, row, _meta) => `${data.count} (${row.licenses.new_student})`,
      },
      {
        data: 'licenses',
        render: ({ count, new_student }) => Math.max(count - new_student, 0),
      },
      { data: 'ebooks', render: countPlusInfo },
      { data: 'teoriakoe' },
      { data: 'supervisions', render: countPlusInfo },
      { data: 'online_lessons', render: countPlusInfo },
      { data: 'web_services' },
      { data: 'email' },
    ]

    const urlSettings = {
      ajax: {
        url: '/reports/school_overviews',
        type: 'GET',
        dataType: 'json',
        data: (d) => {
          d.start_time = document.getElementById('start-date').value
          d.end_time = document.getElementById('end-date').value
        },
        dataSrc: (data) => data,
      },
    }

    settings.columns = overviewColumns
    tables.push($('#school-overviews').DataTable({ ...settings, ...urlSettings }))
    settings.columns = Array.from(document.querySelectorAll('#student-count thead th'), (th) => ({
      data: th.dataset.col,
    }))
    urlSettings.ajax.url = '/reports/student_count'
    tables.push($('#student-count').DataTable({ ...settings, ...urlSettings }))

    document.getElementById('reload-btn').onclick = (event) => {
      tables.forEach((t) => t.ajax.reload())
    }

    function loadBox(count, info, type, row, meta) {
      if (info.length < 1) return count

      const id = `${meta.row}_${meta.col}`

      return `
        <div class="flex items-center gap-2">
          <div>${count}</div>
          <div class="group">
            <button type="button"
              class="iconify flowbite--info-circle-solid icon-xs text-blue-300 cursor-pointer hover:text-blue focus:text-blue-600 group-has-[:popover-open]:text-blue"
              popovertarget="${id}"
              style="anchor-name: ${id};">
            </button>
            <dialog id="${id}"
              class="z-10 max-w-[min(440px,100vw)] bg-neutral-50 font-normal shadow-md border border-gray-300 py-3 px-4 translate-y-1"
              @keydown.esc.stop=""
              popover
              style="position-anchor: ${id}; position-area: bottom;"
            >
              <div class="grid grid-cols-[1fr_auto]">
                ${info
                  .map(
                    (r) => `
                  <div class="border-b py-1">${r.title}</div>
                  <div class="border-b py-1 ps-4 font-semibold">${r.count}</div>
                `,
                  )
                  .join(' ')}
              </div>
            </dialog>
          </div>
        </div>
      `
    }
  }
}
